// @flow

import React, { Component } from 'react';
import {Icon} from 'react-fa';
import _ from 'lodash';

import SideBar from './SideBar.jsx';


type T_BtProps = {
  icon       : string,
  bt_active  : string,
  fun        : () => void,
  text       : string,
  name?      : string,
  disabled?  : boolean,
  sidebar    : SideBar,
  small_text?: boolean,
  id?        : string
};



export default class SideBt extends Component<T_BtProps> {
  click: () => void;
  
  
  constructor(props: T_BtProps) {
    super(props);
    
    this.click = this.click.bind(this);
  }
  
  
  
  disabled(): boolean {
    if (_.has(this.props, 'disabled') && typeof this.props.disabled === 'boolean') {
      return this.props.disabled;
    }
    else {
      return false;
    }
  }
  
  
  
  click(): void {
    if (! this.disabled()) {
      const name = this.props.name || this.props.text;
      
      this.props.sidebar.setState({bt_active: this.props.sidebar.state.bt_active === name ? '' : name}, this.props.fun);
    }
  }
  
  
  
  render() {
    const name  = this.props.name || this.props.text,
          style = name === this.props.bt_active ? {style: {backgroundColor: '#686868'}} : null,
          cls   = {};
    
    let id = {};
    
    if (this.disabled()) {
      cls.className = 'sbt_disabled';
    }
    
    if (this.props.id != null) {
      id = {id: this.props.id};
    }
    
    return (
      <div className='SideBt' {...style} onClick={this.click} {...id}>
        <span {...cls}>
          <Icon name={this.props.icon} size='lg' />
          <br />
          {this.props.small_text ?
            <span className='BTSmall'>
              {this.props.text}
            </span>
          :
            this.props.text
          }
        </span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/SideBt.jsx